import { paserParams } from "../../until"
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient"
import { IPermissionMenu } from "../customer/customerApi"
import { IGroupTypeList } from "../groupCustomerV2/groupCustomerV2Api"

export interface IRecycleCustomer {
  id: number
  name: string
  CCCD: string
  taxCode: string
  birthday: string
  gender: number
  phone: string
  profession: Profession
  statusMarital: number
  address: string
  email: string
  businessCheck: number
  province: Province
  rankTitle: RankTitle
  code?: string
  unitTitle?: string
  groupPermissionId: number
}

export interface Profession {
  title: string
}

export interface Province {
  title: string
}

export interface RankTitle {
  id: number
  title: string
  icon: string
}

export interface IRecycleGroupCustomer {
  id: number
  title: string
  description: string
  type: number
  status: number
  idAdmin: number
  nameAdmin: string
  dateCreate: string
  units: Item[]
  tags: Item[]
  countCustomer: number
}

export interface Item {
  id: number
  title: string
}

// danh sách khách hàng đã xóa
export const getListRecycleCustomer = async (
  limit?: number, pageNumber?: number, search?: string, unitId?: number, businessCheck?: number,
) => {
  const path = "customer/listCustomerRecyclebin"
  const params = {
    limit, pageNumber, search, businessCheck, unitId

  }
  const result: ResponseSuccessTotal<IRecycleCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const restoreCustomer = async (
  id: number[]
) => {
  const path = "customer/restoreCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};

// danh sách nhóm khách hàng đã xóa

export const getListRecycleGroupCustomer = async (
  permittedCategoryCarIds: number[],
  limit?: number, pageNumber?: number, unitTempId?: number, search?: string
) => {
  const path = "groupCustomerV2/listGroupRecyclebin"
  const params = {
    permittedCategoryCarIds,
    limit, pageNumber, unitTempId, search

  }
  const result: ResponseSuccessTotal<IGroupTypeList[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const restoreGroupCustomer = async (
  id: number[]
) => {
  const path = "groupCustomer/restoreGroupCustomer"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, paserParams(params, undefined)
  );
  return result;
};
